import Icon from '../../../UI/Icon'

const TopUpCard = ({ currency, topUpAmount, onSelect }) => {
  const amount = topUpAmount[currency]

  return (
    <button
      className="relative w-[25%] px-[20px] pb-[16px] pt-[40px] flex flex-col items-center border-[#FFE4D4] border-[1px] bg-top-up-card rounded-[24px] hover:border-[#F79009] hover:!bg-none hover:shadow-top-up-card-hover transition-all duration-200 ease"
      onClick={() => onSelect(topUpAmount.discounted_price || topUpAmount.price)}
    >
      {topUpAmount.best_choice && (
        <img
          src="/assets/icon/best-choice.svg"
          alt="Best Choice"
          draggable={false}
          className="absolute top-[-5px] right-[-5px] w-[113px] h-[113px]"
        />
      )}

      <div className="w-[72px] h-[72px] flex items-center justify-center">
        <img src={topUpAmount.icon} alt={topUpAmount.title} />
      </div>

      <h4 className="text-2xl text-primary-100 font-medium text-center mt-[4px]">
        {topUpAmount.title}
      </h4>

      <div className="mt-[40px] w-full flex items-center justify-center flex-col">
        <h5 className="text-[48px] h-[58px] leading-[58px] text-primary-100 font-bold">
          {amount?.value} <span className="text-[16px]">{currency}</span>
        </h5>

        {!!amount?.equal_to && (
          <span className="mt-[8px] text-base text-primary-100 font-normal">
            Equal to {amount.equal_to}€
          </span>
        )}
      </div>

      <div className="mt-[40px] h-[32px] flex items-center px-[10px] rounded-[100px] bg-[#FEEBDD] ">
        <Icon name="discount-medal" className="w-[16px] h-[16px] mr-[4px]" />

        <span className="text-[12px] text-primary-100 font-medium">
          Discount {topUpAmount.discount}%
        </span>
      </div>

      <div className="w-full flex items-center justify-center mt-[24px] text-primary-100">
        {topUpAmount.discounted_price ? (
          <>
            <div className="flex items-center">
              <span className="text-[16px] font-medium">Only&nbsp;</span>

              <span className="text-[24px] font-bold">
                {topUpAmount.discounted_price}

                <span className="text-[16px]">€</span>
              </span>
            </div>

            <span className="line-through mt-[4px] ml-[8px] text-[16px] font-medium">
              {topUpAmount.price}€
            </span>
          </>
        ) : (
          <span className="text-[24px] font-bold">
            {topUpAmount.price}

            <span className="text-[16px]">€</span>
          </span>
        )}
      </div>

      <div className="bg-primary-button hover:bg-primary-button-hover mt-[40px] !h-[44px] !w-[160px] font-semibold text-lg text-white leading-[24px] flex items-center justify-center rounded-[8px] transition-colors duration-200 ease">
        Select
      </div>
    </button>
  )
}

export default TopUpCard
